import React, { useState } from 'react';
import { 
  Container,
  Typography, 
  Box,
  Button,
  IconButton,
  Paper,
  ToggleButton,
  ToggleButtonGroup
} from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DeleteIcon from '@mui/icons-material/Delete';
import apiService from '../../../services/apiService';
import './ExcelUpload.css';

const ExcelUpload = () => {
  const [file, setFile] = useState(null);
  const [stage, setStage] = useState('assign');
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState('');

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile && selectedFile.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
      setFile(selectedFile);
      setError('');
    } else {
      setError('Por favor seleccione un archivo Excel (.xlsx)');
      setFile(null);
    }
  };

  const handleUpload = async () => {
    if (!file) return;

    setUploading(true);
    setError('');

    const formData = new FormData();
    formData.append('file', file);
    formData.append('stage', stage);

    try {
      await apiService.post('/prospect/uploadExcel', formData);
      setFile(null);
    } catch (error) {
      setError('Error al subir el archivo. Por favor intente nuevamente.');
      console.error('Error uploading file:', error);
    } finally {
      setUploading(false);
    }
  };

  const handleStageChange = (event, newStage) => {
    if (newStage !== null) {
      setStage(newStage);
    }
  };

  const clearFile = () => {
    setFile(null);
    setError('');
  };

  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h5" gutterBottom align="center" sx={{ mb: 4 }}>
          Carga Masiva de Datos
        </Typography>

        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 4 }}>
          <ToggleButtonGroup
            value={stage}
            exclusive
            onChange={handleStageChange}
            aria-label="tipo de carga"
            color="primary"
          >
            <ToggleButton value="assign">
              Asignación de Asesores
            </ToggleButton>
            <ToggleButton value="results">
              Resultados de Llamadas
            </ToggleButton>
          </ToggleButtonGroup>
        </Box>

        <Box 
          sx={{ 
            border: '2px dashed #ccc',
            borderRadius: 2,
            p: 4,
            textAlign: 'center',
            backgroundColor: '#fafafa',
            cursor: 'pointer',
            '&:hover': {
              borderColor: 'primary.main',
              backgroundColor: '#f0f0f0'
            }
          }}
          onClick={() => document.getElementById('fileInput').click()}
        >
          <input
            id="fileInput"
            type="file"
            accept=".xlsx"
            onChange={handleFileChange}
            style={{ display: 'none' }}
          />
          
          <CloudUploadIcon sx={{ fontSize: 48, color: 'primary.main', mb: 2 }} />
          
          {file ? (
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
              <Typography>{file.name}</Typography>
              <IconButton size="small" onClick={(e) => { e.stopPropagation(); clearFile(); }}>
                <DeleteIcon />
              </IconButton>
            </Box>
          ) : (
            <Typography>
              Haga clic o arrastre un archivo Excel aquí
            </Typography>
          )}
        </Box>

        {error && (
          <Typography color="error" sx={{ mt: 2, textAlign: 'center' }}>
            {error}
          </Typography>
        )}

        <Box sx={{ mt: 4, textAlign: 'center' }}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleUpload}
            disabled={!file || uploading}
            startIcon={<CloudUploadIcon />}
            sx={{ minWidth: 200 }}
          >
            {uploading ? 'Subiendo...' : 'Subir Archivo'}
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default ExcelUpload;